import React from 'react';
import PropTypes from 'prop-types';
import GlobalStyle from '../components/Atoms/GlobalStyle';
import navLinks from '../constants/NavLinks';
import Footer from '../components/Organisms/Footer/Footer';

const GameLayout = ({ children }) => (
	<>
		<GlobalStyle />
		{children}
		<Footer links={navLinks.footerLinks} />
	</>
);

export default GameLayout;

GameLayout.defaultProps = {
	children: null,
};

GameLayout.propTypes = {
	children: PropTypes.node,
};
